import { createFileRoute } from "@tanstack/react-router"
import { BackgroundRemoverScreenWrapper } from "./-BackgroundRemoverPage"

export const Route = createFileRoute("/tools/background-remover")({
  component: BackgroundRemoverScreenWrapper,
})
